import { useQuery } from "@tanstack/react-query";
import type { TaxProSummary } from "../api/summary";
import { fetchSummaryInfo } from "../api/summary";

export const useTaxProInfo = () => {
  const {
    data: taxProInfo,
    isLoading: isLoadingTaxProInfo,
    isError: isErrorTaxProInfo,
    error: errorTaxProInfo,
  } = useQuery<TaxProSummary, Error>({
    queryKey: ["taxProInfo"],
    queryFn: fetchSummaryInfo,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return {
    taxProInfo,
    isLoadingTaxProInfo,
    isErrorTaxProInfo,
    errorTaxProInfo,
  };
};
